<template>
  <div class="block-wrap block-specification" style="padding: 10px">
    <div v-for="(s, sindex) in specifications" :key="sindex">
      <el-form class="title-bg" ref="skuForm" :model="s" inline>
        <span style="font-size: 14px;">规格名：</span>
        <template>
          <el-select v-model="s.id" @change="(val) => handleSpecChanged(val,sindex)">
            <el-option
              v-for="(o, oindex) in salePropList"
              :key="oindex"
              :label="o.saleAttrName"
              :value="o.saleAttrDicId"
              :disabled="specifications.findIndex(i => i.id === o.saleAttrDicId) != -1"
            ></el-option>
          </el-select>
          <!-- <el-input
            style="width: 140px"
            v-model="s.name"
            @blur="changeSpec"
          ></el-input> -->
        </template>
        <el-button
          style="float: right"
          type="link" @click="removeSpName(sindex)">删除
        </el-button>
      </el-form>
      <!-- <div v-if="showAddSkuTips && sindex === 0 && !isGroupPuhuo" class="add-sku-tips">
        <div>如需添加新的规格值,请至<el-link @click="changeToBase">【基础资料】</el-link>进行添加</div>
        <span @click="handleNoTips" class="tips-btn">不再提示</span>
      </div> -->
      <div class="specification-value">
        <div style="display: inline-block; padding-top: 7px; padding-left: 10px">规格值：</div>
        <vue-draggable
          class="specification-value-flex"
          v-model="specifications[sindex].values"
          filter=".drag-ignore_item"
          handle=".drag-icon-wrap"
          :group="{ name: s.propId, pull: 'clone', put: false }"
          :animation="500"
        >
          <div v-for="(v, vi) in specifications[sindex].values" :key="v.valueKey" class="specification-value-flex_item">
            <el-form ref="specFormRef" :key="vi" :model="v" inline>
              <el-form-item prop="value" :rules="genFormItemValueRule(s, v, vi)">
                <div class="del-input-wrap">
                  <el-input
                    :ref="`${sindex}-${vi}`"
                    placeholder="请输入"
                    class="specification-value-flex_input"
                    @keyup.enter.native="e => valueEnter(sindex, vi)"
                    @change="(val) => handleSpecValueChanged(val,sindex,vi)"
                    v-model="v.value"
                  >
                  </el-input>
                  <el-checkbox
                    style="margin-left: 8px"
                    v-model="v.checked"
                    @change="onChangeCheckbox"
                    :disabled="v.checked && specifications[sindex].values.filter(item => item.checked).length === 1"
                  ></el-checkbox>
                  <div @click="removeSpValue(sindex, vi, v)" class="del-btn">
                    <i class="el-icon-close" />
                  </div>
                  <drag-item-content></drag-item-content>
                </div>
              </el-form-item>
                  <div v-if="sindex === 0" class="specification-value-flex_img">
                    <ImgUpload
                      :width="80"
                      :height="80"
                      :file="v.imageUrl"
                      @upload-success="url => imageUploadSuccess(url, v)"
                      @del="() => imageUploadDel(v)"
                      :limitSuffix="imgLimitSuffix"
                      :isSingle="true"
                      :isPureType="false"
                    />
                  </div>
            </el-form>
          </div>
          <div
            v-if="specifications[sindex].values.length <= specSingleLimit" 
            class="specification-value-flex_item drag-ignore_item"
          >
            <el-button @click="addSpValue(sindex)" type="link">添加规格值</el-button>
          </div>
        </vue-draggable>
        <!-- <div class="tips ft-12 ml-70" v-if="sindex === 0" style="color: #ccc">
          <span
            >默认取商品第一张主图，买家选择不同规格会看到对应规格图片，图片大小不超过2M，长宽比为1:1，建议尺寸：800 x
            800像素，建议格式：png，jpg，jpeg格式</span
          >
        </div> -->
      </div>
    </div>
    <div class="title-bg">
      <el-button @click="handleAddSpName">添加商品规格</el-button>
    </div>
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload';
import { dragItemMixin } from '../../../utils/mixins';
import { cloneDeep } from 'lodash';
import { getBytesCount } from '@utils/data';

export default {
  inject: {
    isGroupPuhuo: {
      default: false,
    },
  },
  components: {
    ImgUpload,
  },
  mixins: [dragItemMixin],
  model: {
    prop: 'values',
    event: 'change',
  },
  props: {
    values: {
      type: Array,
      default() {
        return [];
      },
    },
    salePropList:{
      type: Array,
      default() {
        return [];
      },
    },
    changeToBase: {
      // 打开基础资料编辑
      type: Function,
      default: () => {},
    },
    specSingleLimit: {
      type: Number, // 最大规格值数量
      default: 10,
    },
    maxSpecNumLimit: {
      type: Number, // 最大规格数量
      default: 3,
    },
    imgLimitSuffix: {
      // 图片类型限制
      type: String,
      default: '.jpg,.jpeg,.png,.gif',
    },
    isCheckImg:{
      type:Boolean,
      default: true
    }
  },
  data() {
    return {
      specifications: [],
      showAddSkuTips: true,
      imgErrMsgs: {},
    };
  },
  computed: {},
  watch: {
    values: {
      handler(v) {
        this.specifications = cloneDeep(v);
      },
      deep: true,
      immediate: true,
    }
  },
  mounted() {
    const noTips = localStorage.getItem('noSecTips');
    if (noTips === '1') {
      this.showAddSkuTips = false;
    }
  },
  methods: {
    // 规格值回车事件
    valueEnter(sindex, vindex) {
      let nextInputVm = this.$refs[`${sindex}-${vindex + 1}`];
      nextInputVm = nextInputVm ? nextInputVm[0] : nextInputVm;
      if (nextInputVm) {
        // 聚焦到下一个
        nextInputVm.focus();
      }
    },
    async validate() {
      const specificationValid = await this.validateSpecForm();
      if (!specificationValid) {
        return false;
      }
      return true;
    },
    genFormItemValueRule(specItem, v, vi) {
      let valueValidator = (rule, value, callback) => {
        // if (v.checked) {
          if (value) {
            callback();
          }else{
            callback(new Error(`规格值必填`));
          }
        // }
        
      };

      return [ {required: v.checked, message: '规格值必填',trigger: ['blur','change']}];
      // return [ {required: v.checked, message: '规格值必填',trigger: ['blur','change']},{validator: valueValidator ,trigger: ['blur','change']}];
    },
    validateSpecForm() {
      const valueForms = this.$refs.specFormRef;
      const skuForms = this.$refs.skuForm || [];
      return new Promise(resolve => {
        if (!valueForms || valueForms.length === 0) {
          resolve(true);
          return false;
        }
        const promiseList = valueForms.concat(Array.isArray(skuForms) ? skuForms : [skuForms]).map(item => {
          return new Promise(resolve => {
            item.validate(valid => {
              resolve(valid);
            });
          });
        });
        Promise.all(promiseList)
          .then(results => {
            const allValid = results.every(result => result);
            resolve(allValid);
          })
          .catch(() => {
            console.log('validateSpecForm has Error');
            resolve(false);
          });
      });
      console.log(allpro, '----allpro--')
    },
    genFormItemImgRule(v, specItem, ref) {
      let valueValidator = async (rule, value, callback) => {
        // if (v.checked) {
          const refImg = this.$refs[ref];
          if (v.imageUrl && refImg && refImg[0]) {
            let errMsg = await refImg[0].method_validImage();
            if (errMsg) {
              return callback(new Error(errMsg));
            } else {
              callback();
            }
          }
        // }
        callback();
      };
      return [
        {
          required: true,
          validator: valueValidator,
        },
      ];
    },

    valueInput(v, s) {
      // window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
      // this.$emit('fieldChanged');
      this.changeSpec();
    },
    onChangeCheckbox() {
      window.__spcificationCheckbox_changed = true;
      this.$emit('fieldChanged');
    },

    imageUploadSuccess(url, v, sindex, vi) {
      this.checkImgError && this.checkImgError(); // 淘宝用的
      v.imageUrl = url;
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      this.$emit('file-upload', url);
      this.$emit('fieldChanged');
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    imageUploadDel(v, sindex, vi) {
      v.imageUrl = '';
      this.checkImgError && this.checkImgError(); // 淘宝用的

      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      this.$emit('fieldChanged');
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    handleNoTips() {
      this.showAddSkuTips = false;
      localStorage.setItem('noSecTips', 1);
    },
    // 规格名变更
    handleSpecChanged(val,pindex){
        let pItem = this.specifications[pindex]
        let obj = this.salePropList.find(i => i.saleAttrDicId == val)
        pItem.name = obj.saleAttrName
        this.changeSpec()
    },
    // 规格值变更
    handleSpecValueChanged(val,pindex,cindex){
        let pItem = this.specifications[pindex]
        pItem.values[cindex].value = val
        pItem.values[cindex].valueKey = val
        this.changeSpec();
    },
    changeSpec(){
        this.$emit('fieldChanged');
        this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
    },
    // 添加规格值
    addSpValue(index) {
      // if (index === 0) voidValue.imageUrl = '';
      const { values } = this.specifications[index];
      const voidValue = this.gernerateDefaultSpecValueItem()
      values.push(voidValue);
      // this.specifications[index].values = formatSpecValues(values, cloneDeep(valueItemRule));
      // window.__spcificationImg_changed = voidValue.valueKey // 用于skuList生成时的图片取值规则
      // this.fieldChanged();
    },
    async handleAddSpName() {
        // const specifications = cloneDeep(this.specifications);
        const voidValue = this.gernerateDefaultSpecValueItem()
        let newSpec = {
          checked:true,
          name:'',
          nameKey:'',
          structured:false,
          values:[voidValue],
        }
        this.specifications.push(newSpec);
        return false;
    },
    removeSpName(index){
        this.specifications.splice(index, 1)
        this.changeSpec();
    },
    removeSpValue(sindex, index, v){
      const _copy = [].concat(this.specifications[sindex].values);
      _copy.splice(index, 1);
      this.$set(this.specifications[sindex], 'values', _copy);
      this.changeSpec();
    },
    gernerateDefaultSpecValueItem(){
      let voidValue = {
        checked: true,
        name:'',
        nameKey:'',
        value: '',
        valueKey: this.$utils.genkey.get('v'),
        imageUrl:'',
      }
      return voidValue
    }
  },
};
</script>

<style lang="scss" scoped>
.block-wrap {
  border: 1px solid #dcdfe6;

  .input-value {
    display: inline-block;
  }
  .add-sku-tips {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 2px;
    padding: 5px 10px;
    font-size: 12px;
    margin-top: 10px;
  }
  .tips-btn {
    cursor: pointer;
  }
}
.title-bg {
  background: #f8f8f8;
  padding: 7px 10px;
  // ::v-deep .el-input input {
  //   background: #F8F8F8 !important;
  // }
}

.specification-value {
  &-flex {
    display: inline-flex;
    flex-wrap: wrap;
    width: 90%;
    // position: relative;
    // top: -16px;
    &_item {
      margin-right: 10px;
      margin-bottom: 15px;
    }
    &_img {
      width: 100%;
      margin-top: 10px;
      position: relative;
    }
    .el-input,
    .el-select {
      width: 160px;
    }
  }
  ::v-deep .el-form-item__error {
    position: relative;
  }
}
.del-input-wrap {
  position: relative;
  padding-right: 10px;
  .input-remark {
    margin-left: 10px;
  }
  &:hover {
    .del-btn {
      display: flex;
    }
  }
  .del-btn {
    cursor: pointer;
    display: none;
    position: absolute;
    color: #fff;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.3);
    justify-content: center;
    align-items: center;
  }
  .del-btn {
    width: 18px;
    height: 18px;
    top: 0;
    right: 0;
    border-radius: 50%;
    transform: translate(45%, -45%);
  }
}
.remarkWrap {
  margin-top: 5px;
}
.block-specification {
  max-height: 444px;
  overflow-y: auto;
}
</style>
